import { get } from 'lodash';
import PropTypes from 'prop-types';
import { Component, Suspense, lazy } from 'react';

import { displayNotif } from 'hb-react/shared/helpers/notifications';
import { gatewayList } from 'helpers/paymentGateway';

const PaymentBraintree = lazy(() =>
  import('hb-react/frontoffice/components/payments/PaymentBraintree'),
);
const PaymentStripe = lazy(() =>
  import('hb-react/frontoffice/components/payments/PaymentStripe'),
);

const PaymentPaypal = lazy(() =>
  import('hb-react/frontoffice/components/payments/PaymentPaypal'),
);

class Payment extends Component {
  renderPaypal = () => {
    const {
      fundId,
      onHandlePaymentTransaction,
      onHandleCancelPayment,
      amount,
      currency,
      additionalData,
    } = this.props;

    return (
      <PaymentPaypal
        commit
        amount={amount}
        currency={currency}
        createOrderUrl={Routes.paypal_create_order_path()}
        executePaymentCallback={onHandlePaymentTransaction}
        payment_type="Donation::Fund"
        payment_type_id={fundId}
        cancelCallback={onHandleCancelPayment}
        failCallback={(error) => {
          onHandleCancelPayment();
          displayNotif(
            'error',
            get(error, ['responseText']) ||
              error?.response?.data?.errors ||
              __('Sorry, an error occurred'),
          );
        }}
        additionalData={additionalData}
      />
    );
  };

  renderStripe = () => {
    const {
      paymentAccountExternalId,
      onHandleSuccessPayment,
      onHandleCancelPayment,
      campaign,
      amount,
      currency,
      additionalData,
      url,
      email,
      fundId,
    } = this.props;

    const { firstname, lastname } = additionalData.donation_order;
    const name = `${firstname} ${lastname}`;

    return (
      <PaymentStripe
        payment_type="Donation::Fund"
        payment_type_id={fundId}
        payment_campaign_id={campaign.id}
        stripeAccountId={paymentAccountExternalId}
        title={campaign.title}
        amount={Math.round(amount * 100)}
        currency={currency}
        endpointUrl={url}
        endpointData={additionalData}
        onPaymentSuccess={onHandleSuccessPayment}
        onPaymentCancel={onHandleCancelPayment}
        userEmail={email}
        userName={name}
      />
    );
  };

  renderBraintree = () => {
    const {
      onHandlePaymentTransaction,
      onHandleCancelPayment,
      fundId,
      amount,
      currency,
      paymentIsRecurring,
    } = this.props;

    return (
      <PaymentBraintree
        getClientTokenUrl={Routes.braintree_to_charge_path({
          payment_type: 'Donation::Fund',
          payment_type_id: fundId,
        })}
        onGetNonce={onHandlePaymentTransaction}
        amount={amount}
        currency={currency}
        paymentIsRecurring={paymentIsRecurring}
        options={{
          locale: 'en_US',
        }}
        submitButtonText={s__('Donations|Donate')}
        failCallback={(error) => {
          onHandleCancelPayment();
          displayNotif(
            'error',
            get(error, ['responseText']) ||
              error?.response?.data?.errors ||
              __('Sorry, an error occurred'),
          );
        }}
        displayInModal
        closeBraintreeModal={onHandleCancelPayment}
      />
    );
  };

  render() {
    const { paymentGateway } = this.props;

    let paymentComponent = null;

    switch (paymentGateway) {
      case 'Paypal':
        paymentComponent = this.renderPaypal();
        break;

      case 'Stripe':
        paymentComponent = this.renderStripe();
        break;

      case 'Braintree':
        paymentComponent = this.renderBraintree();
        break;

      default:
        paymentComponent = null;
    }

    return <Suspense fallback={null}>{paymentComponent}</Suspense>;
  }
}

Payment.propTypes = {
  campaign: PropTypes.object.isRequired,
  onHandlePaymentTransaction: PropTypes.func.isRequired,
  onHandleSuccessPayment: PropTypes.func.isRequired,
  onHandleCancelPayment: PropTypes.func.isRequired,
  fundId: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  paymentGateway: PropTypes.oneOf(gatewayList).isRequired,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currency: PropTypes.object.isRequired,
  paymentIsRecurring: PropTypes.bool.isRequired,
  paymentAccountExternalId: PropTypes.string,
  additionalData: PropTypes.object,
};

export default Payment;
